export function safeJsonParse(text) {
  if (typeof text !== "string") return null;
  const trimmed = text.trim();
  if (!trimmed) return null;
  try {
    return JSON.parse(trimmed);
  } catch {
    return null;
  }
}

function isPlainObject(value) {
  return (
    value !== null &&
    typeof value === "object" &&
    !Array.isArray(value) &&
    Object.prototype.toString.call(value) === "[object Object]"
  );
}

function firstString(value) {
  if (typeof value === "string" && value.trim()) return value;
  if (Array.isArray(value)) {
    const found = value.find((v) => typeof v === "string" && v.trim());
    return found || "";
  }
  return "";
}

export function normalizeBackendErrorPayload(payload) {
  // Typical shapes:
  // - { errors: { phone: "..." } }
  // - { errors: "Some error" }
  // - { error: "Some error" }
  // - { message: "Some error" }
  if (!payload) return { fieldErrors: {}, message: "" };

  if (isPlainObject(payload.errors)) {
    const fieldErrors = {};
    for (const [k, v] of Object.entries(payload.errors)) {
      const msg = firstString(v);
      if (msg) fieldErrors[k] = msg;
    }
    return { fieldErrors, message: "" };
  }

  const msgFromErrors = firstString(payload.errors);
  if (msgFromErrors) return { fieldErrors: {}, message: msgFromErrors };

  const msgFromError = firstString(payload.error);
  if (msgFromError) return { fieldErrors: {}, message: msgFromError };

  const msgFromMessage = firstString(payload.message);
  if (msgFromMessage) return { fieldErrors: {}, message: msgFromMessage };

  return { fieldErrors: {}, message: "" };
}

export async function parseFetchErrorResponse(response) {
  try {
    const text = await response.text();
    const json = safeJsonParse(text);
    if (json) return normalizeBackendErrorPayload(json);
    return { fieldErrors: {}, message: "" };
  } catch {
    return { fieldErrors: {}, message: "" };
  }
}

export function pickAnyFieldError(fieldErrors) {
  if (!fieldErrors || !isPlainObject(fieldErrors)) return "";
  const firstKey = Object.keys(fieldErrors)[0];
  return firstKey ? fieldErrors[firstKey] : "";
}

